import PolicyLayout from './PolicyLayout';
import {
  COMPANY_NAME,
  LEGAL_UPDATED,
  SITE_DOMAIN,
  SITE_NAME,
  SUPPORT_EMAIL,
} from '../constants/site';

export default function RefundPolicy() {
  return (
    <PolicyLayout
      title="Refund Policy"
      updated={LEGAL_UPDATED}
      intro={`This Refund Policy explains when ${COMPANY_NAME}, operator of ${SITE_DOMAIN} (${SITE_NAME}), may issue a refund or replacement for design software and digital marketing software purchases.`}
    >
      <h2>14-day activation window</h2>
      <p>
        If a purchased title will not activate on a supported Windows or macOS
        system within <strong>14 days</strong> of purchase, contact{' '}
        {SUPPORT_EMAIL} with your order reference. We will attempt a replacement
        download or licence reset first.
      </p>

      <h2>Eligible refunds</h2>
      <p>Refunds may be approved when:</p>
      <ul>
        <li>
          The software cannot be activated after reasonable support attempts
          within the 14-day window.
        </li>
        <li>
          You were charged more than once for the same order due to a processing
          error.
        </li>
        <li>
          We cancel an order before delivery because of stock, licensing, or
          compliance issues.
        </li>
      </ul>

      <h2>Non-refundable situations</h2>
      <p>Refunds are generally not available when:</p>
      <ul>
        <li>The licence has been successfully activated and used.</li>
        <li>
          You purchased the wrong category and request a change after download
          links were issued (we may offer an upgrade credit instead).
        </li>
        <li>
          Compatibility issues arise on unsupported operating systems or
          environments.
        </li>
        <li>The request is made after the 14-day window without exceptional cause.</li>
      </ul>

      <h2>How to request</h2>
      <p>
        Email {SUPPORT_EMAIL} with your order ID, purchase date, and a short
        description of the issue. We typically respond within two business days.
      </p>

      <h2>Processing time</h2>
      <p>
        Approved refunds are returned to the original payment method. Bank or
        card processor timelines may take several business days after we issue
        the refund.
      </p>

      <h2>Chargebacks</h2>
      <p>
        Please contact us before filing a payment dispute. Friendly resolution is
        faster for both sides and helps us keep accurate records of your licence.
      </p>
    </PolicyLayout>
  );
}
